// config/casl.ts
import {
  AbilityBuilder,
  createMongoAbility,
  MongoAbility,
} from "@casl/ability";
import { createContext, useContext } from "react";
import { RolePermission } from "constants/types/permission";

// Define AppAbility: [Action, Subject]
export type AppAbility = MongoAbility<[string, string]>;

export const buildAbilityForRole = (
  rolePermissions: RolePermission[],
): AppAbility => {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  rolePermissions.forEach((rp) => {
    const [subject, action] = rp.permissionCode.split(":");
    if (subject && action) {
      can(action, subject);
    }
  });

  return build();
};

export const buildAbilityForPermissions = (
  permissionCodes: string[],
): AppAbility => {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  if (permissionCodes.includes("*:*")) {
    can("manage", "all");
    return build();
  }

  permissionCodes.forEach((code) => {
    const parts = code.split(":");
    const subject = parts[0];
    const action = parts[1];
    if (subject && action) {
      can(action, subject);
    } else if (process.env.NODE_ENV === "development") {
      console.warn(`[casl] malformed permission code ignored: "${code}"`);
    }
  });

  return build();
};

export const AbilityContext = createContext<AppAbility>(createMongoAbility());

export const useAbility = (): AppAbility => useContext(AbilityContext);
